import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { updateUser } from 'services/api/users';
import { stringifyAndParseObj } from 'utils';

function useProfile() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const updateUserFn = async(dataToSend) => {
    try{
        setLoading(true);
        let apiData = await updateUser(dataToSend);
        apiData = stringifyAndParseObj(apiData)
        setData(apiData);
        return apiData
    } catch(e) {
        setError(e)
    } finally {
        setLoading(false)
    }
  }

  return {
    updateUserFn,
    loading, 
    data, 
    error
  }
}

export default useProfile;
